import { SVGProps, Ref, forwardRef } from 'react';

export const LoaderOutlinedSize64Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={64} height={64} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M32 7.467A24.533 24.533 0 1 0 56.533 32h4.8A29.333 29.333 0 1 1 32 2.667z"
                fill="currentColor"
            />
        </g>
    </svg>
));
LoaderOutlinedSize64Glyph.displayName = 'LoaderOutlinedSize64Glyph';
